import { render } from "./BottomToolComp.vue?vue&type=template&id=5197e4a8&scoped=true"
import script from "./BottomToolComp.vue?vue&type=script&lang=js"
export * from "./BottomToolComp.vue?vue&type=script&lang=js"

import "./BottomToolComp.vue?vue&type=style&index=0&id=5197e4a8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5197e4a8"]])

export default __exports__